import { CLASSY_LOGIN_DEFAULT_SCOPES } from 'models/sso'
import { Environment } from 'utils/environment'

/**
 * Methods for interacting with our SSO service.
 */
export const onLogin = async (
  { classyStudioDomain, kongClientId, oktaClientId, classyBaseUri }: Environment,
  orgId?: string,
) => {
  const loginResponse = await fetch(
    `/api/auth/login?originalUrl=${encodeURIComponent(window.location.href)}`,
  )
  const state = await loginResponse.json()

  const redirectUri = `https://${classyStudioDomain}/api/auth/callback`

  const ssoLoginParams = {
    client_id: kongClientId as string,
    response_type: 'code',
    state,
    redirect_uri: redirectUri,
    okta_client_id: oktaClientId as string,
    okta_scope: CLASSY_LOGIN_DEFAULT_SCOPES.replace(/,/g, ' '),
    mode: 'json',
    ...(orgId ? {} : { org_id: orgId }),
  }

  // Redirect to SSO on the same domain that the user is on so that cookies are set
  // on the proper domain
  const ssoBaseUrl =
    window.location.host !== classyStudioDomain ? window.location.origin : classyBaseUri

  const ssoPath = '/sso'
  const params = new URLSearchParams(ssoLoginParams)

  const ssoUrl = `${ssoBaseUrl}${ssoPath}?${params}`
  redirect(ssoUrl)
}

/**
 * Client-side only redirect
 */
export const redirect = (url: string) => {
  if (typeof window !== 'undefined') {
    window.location.href = url
  }
}
